var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.style.infoBlockRow},[_c('p',{class:_vm.style.infoBlockRowTitle},[_vm._v(_vm._s(_vm.title))]),_c('p',{class:_vm.style.infoBlockRowContent},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }